export interface DocTile {
    model: string;
    label: string;
    icon: string;
    route: string;
}

export interface DocSection {
    id: string;
    label: string;
    icon: string;
    models: string[];
}

export const PROJECT_STATES: Record<string, { label: string; color: string }> = {
    draft: { label: "card.state.draft", color: "warning" },
    stakeholder_approval: { label: "card.state.stakeholderApproval", color: "info" },
    stop: { label: "card.state.stopped", color: "danger" },
    project_ready: { label: "card.state.running", color: "success" },
    cancel: { label: "card.state.cancelled", color: "danger" },
    close: { label: "card.state.closed", color: "secondary" },
    exported: { label: "card.state.exported", color: "info" },
};

export const DOC_SECTIONS: DocSection[] = [
    { id: "requests", label: "card.requests", icon: "fa-file-text-o", models: [
        "general.approval.request", "drawing.approval.request", "request.material.approval",
        "request.sample.approval",
        "request.supplier.approval", "request.information", "inspection.concrete.request",
        "general.inspection.request", "change.proposal.request",
        "change.request", "work.quantity.sheet", "start.new.item",
    ] },
    { id: "letters", label: "card.lettersPayments", icon: "fa-envelope-o", models: [
        "project.letter", "project.internal.memo", "project.stop", "letter.payment",
    ] },
    { id: "reports", label: "card.reports", icon: "fa-bar-chart", models: [
        "daily.report", "weekly.report", "investigation.report",
        "non.conformance.report", "quality.control.report",
    ] },
];

export const DESIGN_DOC_MODELS = new Set([
    "general.approval.request", "drawing.approval.request", "general.inspection.request",
    "change.request", "project.letter", "project.internal.memo", "letter.payment", "weekly.report",
]);

export const DESIGN_TILE_LABELS: Record<string, string> = {
    "general.inspection.request": "nav.req.designInspection",
    "letter.payment": "nav.designPayments",
};

export const DOC_TILES: DocTile[] = [
    { model: "general.approval.request", label: "card.tile.generalApproval",
      icon: "fa-file-text-o", route: "/requests/general-approvals" },
    { model: "drawing.approval.request", label: "card.tile.drawingApprovals",
      icon: "fa-drafting-compass", route: "/requests/drawing-approvals" },
    { model: "request.material.approval", label: "card.tile.materialApprovals",
      icon: "fa-cubes", route: "/requests/material-approvals" },
    { model: "request.sample.approval", label: "card.tile.sampleApprovals",
      icon: "fa-clone", route: "/requests/sample-approvals" },
    { model: "request.supplier.approval", label: "card.tile.supplierApprovals",
      icon: "fa-truck", route: "/requests/supplier-approvals" },
    { model: "request.information", label: "card.tile.informationRequests",
      icon: "fa-info-circle", route: "/requests/rfis" },
    { model: "inspection.concrete.request", label: "card.tile.concreteInspections",
      icon: "fa-cube", route: "/requests/concrete-inspections" },
    { model: "general.inspection.request", label: "card.tile.generalInspections",
      icon: "fa-search", route: "/requests/inspections" },
    { model: "change.proposal.request", label: "card.tile.changeProposals",
      icon: "fa-exchange", route: "/requests/change-proposals" },
    { model: "change.request", label: "card.tile.changeRequests",
      icon: "fa-edit", route: "/requests/change-requests" },
    { model: "work.quantity.sheet", label: "card.tile.workQuantitySheets",
      icon: "fa-table", route: "/requests/work-quantity-sheets" },
    { model: "start.new.item", label: "card.tile.startNewItem",
      icon: "fa-plus-square", route: "/requests/start-new-items" },
    { model: "project.letter", label: "card.tile.letters",
      icon: "fa-envelope", route: "/letters?view=letters" },
    { model: "project.internal.memo", label: "card.tile.internalMemos",
      icon: "fa-file-text-o", route: "/letters?view=memos" },
    { model: "project.stop", label: "card.stopResume",
      icon: "fa-pause-circle", route: "/letters?view=letters" },
    { model: "letter.payment", label: "card.tile.paymentCertificates",
      icon: "fa-money", route: "/payments?view=payments" },
    { model: "daily.report", label: "card.tile.dailyReports",
      icon: "fa-calendar-check-o", route: "/reports?view=daily" },
    { model: "weekly.report", label: "card.tile.weeklyReports",
      icon: "fa-calendar", route: "/reports?view=weekly" },
    { model: "investigation.report", label: "card.investigationReports",
      icon: "fa-gavel", route: "/hse?view=investigation" },
    { model: "non.conformance.report", label: "card.nonConformance",
      icon: "fa-exclamation-triangle", route: "/reports?view=non-conformance" },
    { model: "quality.control.report", label: "card.qualityControl",
      icon: "fa-check-square-o", route: "/reports?view=quality-control" },
];
